// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"89b5c0fa","554":"89b5c0fa","856":"11765848","988":"14ace9ba"}[chunkId] + ".chunk.css";
};